"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.localText = exports.iconVariants = exports.iconColorVariants = void 0;
var icons_1 = __importDefault(require("../../../assets/icons"));
var theme_1 = __importDefault(require("../../../styles/theme"));
exports.iconColorVariants = {
    error: theme_1.default.colors.error,
    info: theme_1.default.textColors.highlight,
    warning: theme_1.default.colors.secondary,
};
exports.iconVariants = {
    error: icons_1.default.error,
    info: icons_1.default.information,
    warning: icons_1.default.warning,
};
exports.localText = {
    content: 'content',
    copy: 'Copy',
};
